module.exports = __webpack_public_path__ + "img/wlylx.0b4ee384.jpg";